import { useEffect, useState, useCallback } from "react";
import { useRouter } from "next/router";
import { IBlock } from "../BlockList/Block";

/**
 * Hook to manage block selection synchronized with URL
 */
export function useBlockSelection(blocks: IBlock[], onSelectedBlock: (block: IBlock) => void): {
	selectedBlock: IBlock | null;
	handleSelectedBlock: (block: IBlock) => void;
} {
	const router = useRouter();
	const { folderUid } = router.query;
	const [selectedBlock, setSelectedBlock] = useState<IBlock | null>(null);

	// Synchronize selectedBlock with URL folderUid
	useEffect(() => {
		if (typeof folderUid === "string" && folderUid.length > 0) {
			const activeBlock = blocks.find((block) => block.id === folderUid);
			if (activeBlock) {
				setSelectedBlock(activeBlock);
			}
		} else {
			setSelectedBlock(null);
		}
	}, [folderUid, blocks]);

	const handleSelectedBlock = useCallback(
		(block: IBlock) => {
			setSelectedBlock(block);
			onSelectedBlock(block);
		},
		[onSelectedBlock],
	);

	return {
		selectedBlock,
		handleSelectedBlock,
	};
}
